// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ksl_J","fullView":"styles_fullView__h1Ebk"};